<template>
    <div class="data-statistics white-bg">
        <el-dialog
                title="请使用微信扫码支付"
                :visible.sync="paymentCode"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                center
                width="400px"
                :before-close="handleClose">
            <div class="dialogCode">
                <qriously :value="code_url" :size="250" />
            </div>
            <p class="paymentTips" v-if="!isOrderPayment"><i class="paymentTips-icon el-icon-error"></i>{{paymentTips}}</p>
            <p class="alreadyPaymentTips" v-if="isOrderPayment"><i class="paymentTips-icon el-icon-error"></i>{{paymentTips}}</p>
        </el-dialog>
        <el-dialog
                title="开通企业会员"
                :visible.sync="openMember"
                width="400px">
            <el-form :model="form" ref="form" label-width="80px" class="demo-ruleForm">
                <el-form-item label="选择年限">
                    <el-input-number v-model="form.year" @change="handleChange" :min="1" :max="3" label="只能开通三年"></el-input-number>
                </el-form-item>
                <el-form-item label="金额合计">
                    <span class="allMoney">{{form.task_price}}元 / {{form.year}}年</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="openMember = false">取消开通</el-button>
        <el-button type="primary" @click="gotoOpen">立即开通</el-button>
      </span>
        </el-dialog>
        <ul class="flex justify-content align-items">
            <li class="item">
                <p class="number">{{count.ep_num}}</p>
                <p class="text">入驻企业</p>
            </li>
            <li class="item">
                <p class="number">{{count.pc_num}}</p>
                <p class="text">认证达人</p>
            </li>
            <li class="item">
                <p class="number">{{changeCount}}</p>
                <p class="text">总浏览量</p>
            </li>
        </ul>
        <div class="release" v-if="this.$store.state.user_type === 0 && this.$store.state.is_auth === 1">
            <el-button type="primary" style="width:100%;" @click="release">立即发布推广</el-button>
        </div>
    </div>
</template>
<script>
import {
    homeData,
    upgradeMember,
    payResult,
    getConfig,
} from '@/config/api.js'
export default {
  name: 'DataStatistics',
    data () {
      return {
          count:{
              ep_num: null,
              pc_num: null,
              show_num: null
          },
          user_type: this.$store.state.user_type,
          openMember: false,
          paymentCode: false,
          form: {
              year: 1,
              task_price:this.money,
          },
          money: '',
          code_url: '',
          out_trade_no: '',
          timer:null,
          paymentTips: '订单未支付',
          isOrderPayment: false,
      }
    },
    methods: {
        getCount () {
            let data = {
                entry_type: 'web'
            };
            this.$post(homeData,data)
                .then(res => {
                    this.count = res.data.count;
                })
                .catch(err => {
                    window.console.log(err);
                });
        },
        release () {
            if (this.$store.state.rank === 0) {
                this.openMember = true;
            } else if (this.$store.state.rank > 0) {
                this.$router.push('/enterprise/release')
            }
        },
        gotoOpen () {
            let data = {
                user_type: this.$store.state.user_type,
                user_id: this.$store.state.user_id,
                task_price: this.form.task_price,
                year: this.form.year,
            };
            this.$post(upgradeMember,data)
                .then(res => {
                    let data = res.data;
                    this.code_url = data.code_url;
                    this.out_trade_no = data.out_trade_no;
                    this.paymentCode = true;
                    this.timer = setInterval( () => {
                        this.paymentResult()
                    },2000)
                })
                .catch(err => {
                    window.console.log(err);
                    setTimeout(() => {
                        this.$message.error('很抱歉， 开通会员失败，请重新开通');
                    }, 1000);
                })
        },
        //支付状态判断
        paymentResult () {
            let data = {
                pay_type: 2,
                out_trade_no: this.out_trade_no,
            };
            this.$post(payResult,data)
                .then(() => {
                    window.clearInterval(this.timer);
                    this.timer = null;
                    this.isOrderPayment = true;
                    this.paymentTips = '订单已支付成功';
                    setTimeout(() => {
                        this.paymentCode = false;
                        this.openMember = false;
                        this.$store.commit('changeRank',1);
                        this.$router.push('/enterprise/release')
                    }, 1000);
                })
                .catch( () => {
                })
        },
        handleChange() {
            if (this.form.year === 1) {
                this.form.task_price = this.money * 1;
            }else if (this.form.year === 2) {
                this.form.task_price = this.money * 2;
            }else if (this.form.year === 3) {
                this.form.task_price = this.money * 3;
            }
        },
        handleClose () {
            this.paymentCode = false;
            this.hideLoading();
            window.clearInterval(this.timer);
            this.timer = null
        },
        getMoney () {
            let data = {
                key: 'annual_fee'
            };
            this.$post(getConfig,data)
                .then(res => {
                    this.money = res.data;
                    this.form.task_price = this.money;
                })
                .catch(err => {
                    window.console.log(err)
                })
        }
    },
    computed: {
      changeCount (x) {
          x = parseFloat(this.count.show_num / 10000).toFixed(1) + '万';
          return x;
      }
    },
    mounted () {
        this.getCount();
        this.getMoney()
    },
    destroyed() {
        this.timer && window.clearInterval(this.timer);
        this.timer = null;
    }
}
</script>
<style scoped>
    .data-statistics{padding:18px 0 25px 0;}
    .item{width:33.3%;text-align: center;border-left:1px #f1f1f1 solid;}
    .item:first-child{border-left:0;}
    .item .number{font-size:18px;height:30px;line-height: 30px;}
    .item .text{color:#999;}
    .release{width:250px;margin:20px auto 0 auto;}
</style>
